var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMultiColorCheckmark = function SvgMultiColorCheckmark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 15 15"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: "100%",
    height: "100%",
    fill: "#F71278",
    rx: "100%"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M10.67 5a.32.32 0 0 0-.219.097L5.562 9.986 3.55 7.974a.32.32 0 1 0-.452.452l2.238 2.238a.32.32 0 0 0 .452 0l5.115-5.115A.32.32 0 0 0 10.671 5"
  })));
};
export { SvgMultiColorCheckmark as ReactComponent };